import { mapState } from "pinia";
import { defineComponent } from "vue";

import WidgetIndicator from "~/components/widget-indicator/widget-indicator.vue";
import ComponentBase from "~/components/component-base";
import { useDashboardStore } from "~/store/dashboard.store";
import { NNumberAnimation } from "naive-ui";
import { isStationReallyOffline } from "~/misc/station-utils";
import { DashboardFilterEnum } from "~/models/dashboard/dashboard-filter.enum";

export default defineComponent({
  extends: ComponentBase,

  components: {
    WidgetIndicator,
    NNumberAnimation,
  },

  data() {
    return {
      old: 0,
      current: 0,
      DashboardFilterEnum,
    };
  },

  computed: {
    ...mapState(useDashboardStore, ['stations']),

    count(): number {
      return this.stations?.filter(s => isStationReallyOffline(s))?.length || 0;
    },

    percentage(): number {
      if (!this.stations || !this.stations.length) {
        return 0;
      }

      return (this.count / this.stations.length) * 100;
    },
  },

  watch: {
    count(value, old) {

      if(old === value) {
        return;
      }

      this.old = old;
      this.current = value;
    }
  },
});
